import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createUserProductDiscountVariables, createUserShippingDiscountVariables } from '@api/graphql/types';
import UserDiscountForm from '../components/UserDiscountForm';
import DateUtils from '@root/utils/DateUtils';
import { DiscountType } from '../types';
import Notification from 'components/Notification';

type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface RouteParams {
    userId: string;
    discountType: DiscountType;
}

type PropType = Props & InjectedIntlProps & RouteComponentProps<RouteParams>;

interface State {
    formData: createUserProductDiscountVariables | createUserShippingDiscountVariables;
}


class UserDiscountCreate extends React.Component<PropType, State> {
    constructor(props: PropType) {
        super(props);
        this.state = {
            formData: {
                user_id: (this.props.match.params.userId) ? this.props.match.params.userId : '',
                is_active: true,
                discount: 0,
                active_from: DateUtils.formatDateTime(new Date()),
                active_to: DateUtils.formatDateTime(new Date()),
            },
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    public onSubmit = (formData: createUserProductDiscountVariables | createUserShippingDiscountVariables) => {
        const discountType = this.props.match.params.discountType;
        if (discountType === DiscountType.productDiscount) {
            return GraphQLClient.mutate({
                mutation: Mutations.createUserProductDiscount,
                variables: formData,
            });
        } else if (discountType === DiscountType.shippingDiscount) {
            return GraphQLClient.mutate({
                mutation: Mutations.createUserShippingDiscount,
                variables: formData,
            });
        } else {
            return Promise.reject(this.props.intl.formatMessage({ id: 'module.user.error.wrong_discount_type' }));
        }
    }

    public render() {
        const { userId, discountType } = this.props.match.params;

        if (!discountType || ((discountType !== DiscountType.productDiscount) && (discountType !== DiscountType.shippingDiscount)) || !userId) {
            Notification.error(this.label('error.wrong_url'));
            return null;
        } else {
            return (
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>{this.props.intl.formatMessage({ id: `module.user.${discountType}_create` })}</h5>
                            </div>
                            <div className="ibox-content">
                                <UserDiscountForm
                                    discountType={discountType}
                                    formData={this.state.formData}
                                    onSubmit={this.onSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserDiscountCreate);



// WEBPACK FOOTER //
// ./src/modules/User/pages/UserDiscountCreate.tsx